/**
 * OrderBookTabs — the two questions a fact answers, kept apart: how margin MOVES over a
 * calendar, and what it is MADE OF right now. Underline tabs with a subtitle each, as the
 * reference does; the choice lives in the URL, so a tab is a link.
 *
 * The trend's subtitle is a prop because the calendar differs by fact: the order book runs
 * on the customer's DELIVERY date, the margin fact on the INVOICE date. Calling both "the
 * delivery calendar" is the conflation the invoice fact exists to end, so the default is the
 * order book's own wording and /margin passes its own.
 */

import React from 'react'
import { TABS, type Tab } from '../hooks/useOrderBookNav'

const TITLE: Record<Tab, string> = { trend: 'Trend', breakdown: 'Breakdown' }
const BREAKDOWN_SUBTITLE = 'who and what it is made of'

export default function OrderBookTabs({ tab, onSelect, trendSubtitle = 'margin over the delivery calendar' }: {
  tab: Tab
  onSelect: (tab: Tab) => void
  /** What the trend tab plots against — see the header for why this is not fixed. */
  trendSubtitle?: string
}): React.JSX.Element {
  const SUBTITLE: Record<Tab, string> = { trend: trendSubtitle, breakdown: BREAKDOWN_SUBTITLE }
  return (
    <div className="flex items-end gap-5 border-b border-line2 px-4" role="tablist" aria-label="Order-book view">
      {TABS.map((option) => {
        const active = option === tab
        return (
          <button
            key={option}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onSelect(option)}
            className={`-mb-px flex items-baseline gap-2 border-b-2 pb-2.5 pt-1 transition-colors ${
              active ? 'border-brand text-ink' : 'border-transparent text-mut hover:text-ink'
            }`}
          >
            <span className="text-[13px] font-semibold">{TITLE[option]}</span>
            <span className="font-mono text-[10px] font-normal text-mut2">{SUBTITLE[option]}</span>
          </button>
        )
      })}
    </div>
  )
}
